export default {
    // ----------Title----------
    reports: 'Reports',
    containersReport: 'Containers Report',
    productsReport: 'Products Report',
    productItemsReport: 'Product Items Report',
    selectLocations: 'Select Locations',
    scopeTheRangeOfTheSearchLocations: 'Scope the range of the search locations',
    dataFilters: 'Data Filters',
    multipleFiltersApplyToDatasetResults: 'Multiple filters apply to dataset results',
    selectSearchLocation: 'Select Search Location',
    youCanSelectMultipleWarehouseLocationsToProceed: 'You can select multiple warehouse locations to proceed',

    exportAllToExcel: `Export All to Excel`,

    // ----------Drawer---------
    advancedFilters: 'Advanced Filters',

    // -----------MUI----------
    createDateFrom: 'Create Date From',
    createDateTo: 'create Date To',
    checkedInAtFrom: 'Check-In At From',
    checkedInAtTo: 'Check-In At To',
    loadDateFrom: 'Load Date From',
    loadDateTo: 'Load Date To',
    startQuery: 'Start Query',
    customerMarking: 'Customer Marking',
    supplierName: 'Supplier Name',
    supplierContact: 'Supplier Contact.',
    supplierPNo: 'Supplier PNo.',
    applyFilters: 'Apply Filters',
    companyPNo: 'Company PNo.',
    courierNo: 'Courier No',
    containerId: 'Container ID',
    signedBy: 'Signed By',
    createdDateTime: 'Created Date Time',
    loadStatus: 'Load Status',
    containerNo: 'Container No',
    id: 'ID',
    depositFee: 'Deposit Fee',
    transportFee: 'Transport Fee',

    toLocation: 'To Location',
    containerMarking: 'Container Marking',
    createdBy: 'Created By',

}